import React, {Component} from 'react';
import {withRouteData} from 'react-static';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faTwitter, faInstagram, faMediumM, faTelegramPlane, faLinkedinIn, faRedditAlien } from '@fortawesome/free-brands-svg-icons'

const SocialLinksStyle = styled.div`
	ul {
		display: block;
	    position: fixed;
	    bottom: 100px;
	    left: 0;
	    padding: 0;
        margin: 0;
	    list-style: none;
	    z-index: 99;
	}
	li {
		&:first-child {
            border-top-right-radius: 5px;
	    }
	    &:last-child {
	        border-bottom-right-radius: 5px;
	    }
	    &.icon-fb {
	        background-color: #3b5998;
	    }
	    &.icon-tw {
	        background-color: #1da1f2;
	    }
	    &.icon-ig {
	        background-color: #f56040;
	    }
	    &.icon-me {
	        background-color: #ffffff;
	    }
	    &.icon-tg {
	        background-color: #0088cc;
	    }
	    &.icon-in {
	        background-color: #007bb5;
	    }
	    &.icon-rd {
	        background-color: #ff4500;
	    }
	}
    .icon-color {
        padding: 8px;
	    line-height: 24px;
	    font-size: 22px;
	    text-align: center;
	    display: block;
	    max-width: 40px;
	    transition: background .2s ease-in-out;
	    
	    &:hover {
	        background: rgba(0,0,0,.2);
	        border-radius: 25px;
	    }
    }
`;

class SocialLinks extends Component {

	render() {

		return (
			<SocialLinksStyle>
				<ul className="hide-for-small-only">
					<li className="icon-tg">
						<a href="https://t.me/ctrgroupico" target="_blank" rel="noopener noreferrer">
							<div className="icon-color">
								<FontAwesomeIcon icon={faTelegramPlane} />
							</div>
						</a>
					</li>
					<li className="icon-me">
						<a href="https://medium.com/@ctrgroup" target="_blank" rel="noopener noreferrer">
							<div className="icon-color">
								<FontAwesomeIcon icon={faMediumM} style={{color: "gray"}} />
							</div>
						</a>
					</li>
					<li className="icon-tw">
						<a href="https://twitter.com/GroupCtr/" target="_blank" rel="noopener noreferrer">
							<div className="icon-color">
								<FontAwesomeIcon icon={faTwitter} />
							</div>
						</a>
					</li>
					<li className="icon-ig">
						<a href="https://www.instagram.com/ctr_group_ico/" target="_blank" rel="noopener noreferrer">
							<div className="icon-color">
								<FontAwesomeIcon icon={faInstagram} />
							</div>
						</a>
					</li>
					<li className="icon-fb">
						<a href="https://www.facebook.com/CTRGroupProject" target="_blank" rel="noopener noreferrer">
							<div className="icon-color">
								<FontAwesomeIcon icon={faFacebookF} />
							</div>
						</a>
					</li>
					<li className="icon-rd">
						<a href="https://www.reddit.com/user/ctr_group" target="_blank" rel="noopener noreferrer">
							<div className="icon-color">
								<FontAwesomeIcon icon={faRedditAlien} />
							</div>
						</a>
					</li>
					<li className="icon-in">
						<a href="https://www.linkedin.com/in/ctr-group-417ba1174" target="_blank" rel="noopener noreferrer">
							<div className="icon-color">
								<FontAwesomeIcon icon={faLinkedinIn} />
							</div>
						</a>
					</li>
				</ul>
			</SocialLinksStyle>
		)
	}
}

export default withRouteData(SocialLinks)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/SocialLinks.js